export default {
  metadata: {
    version: '2.0.0',
    id: 'badge-notification-2.0.0',
    name: 'JDSBadgeV2Notification'
  },
  hierarchy: {
    container: [
      {
        'inner-container': ['label-jds-text', 'symbol-jds-text']
      }
    ]
  },
  base: {
    container: {
      'background-color': '{b_8}',
      'border-radius': '{b_6}',
      'padding-left': '{b_7}',
      'padding-right': '{b_7}',
      'padding-top': '{b_7}',
      'padding-bottom': '{b_7}'
    },
    'inner-container': {
      'flex-direction': '{b_0}',
      'justify-content': '{b_1}',
      'align-items': '{b_2}',
      width: '{b_3}',
      height: '{b_4}',
      'background-color': '{b_5}',
      'border-radius': '{b_6}'
    },
    'label-jds-text': {
      'font-family': '{text_172}',
      color: '{text_62}',
      'font-size': '{text_171}',
      'line-height': '{text_173}',
      'letter-spacing': '{text_174}',
      'font-weight': '{text_175}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: true
    },
    'symbol-jds-text': {
      'font-family': '{text_172}',
      color: '{text_62}',
      'font-size': '{text_171}',
      'line-height': '{text_173}',
      'letter-spacing': '{text_174}',
      'font-weight': '{text_175}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      value: '+',
      hidden: true,
      text: '+'
    }
  },
  variant: {
    kind: {
      dot: {
        'inner-container': {
          show: true
        }
      },
      number: {
        'label-jds-text': {
          hidden: false
        }
      },
      'number-symbol': {
        'label-jds-text': {
          hidden: false
        },
        'symbol-jds-text': {
          hidden: false
        }
      }
    },
    size: {
      small: {
        'inner-container': {
          width: '{b_10}',
          height: '{b_11}'
        }
      },
      medium: {
        'inner-container': {
          width: '{b_12}',
          height: '{b_13}'
        }
      },
      large: {
        'inner-container': {
          width: '{b_15}',
          height: '{b_16}'
        }
      },
      'xtra-large': {
        'inner-container': {
          width: '{b_18}',
          height: '{b_19}'
        },
        'label-jds-text': {
          'font-family': '{text_152}',
          'font-size': '{text_151}',
          'line-height': '{text_153}',
          'letter-spacing': '{text_154}',
          'font-weight': '{text_155}'
        },
        'symbol-jds-text': {
          'font-family': '{text_152}',
          'font-size': '{text_151}',
          'line-height': '{text_153}',
          'letter-spacing': '{text_154}',
          'font-weight': '{text_155}'
        }
      },
      'xtra-xtra-large': {
        'inner-container': {
          width: '{b_21}',
          height: '{b_22}'
        },
        'label-jds-text': {
          'font-family': '{text_152}',
          'font-size': '{text_151}',
          'line-height': '{text_153}',
          'letter-spacing': '{text_154}',
          'font-weight': '{text_155}'
        },
        'symbol-jds-text': {
          'font-family': '{text_152}',
          'font-size': '{text_151}',
          'line-height': '{text_153}',
          'letter-spacing': '{text_154}',
          'font-weight': '{text_155}'
        }
      },
      'xtra-xtra-xtra-large': {
        'inner-container': {
          width: '{b_24}',
          height: '{b_25}'
        },
        'label-jds-text': {
          'font-family': '{text_137}',
          'font-size': '{text_136}',
          'line-height': '{text_138}',
          'letter-spacing': '{text_139}',
          'font-weight': '{text_140}'
        },
        'symbol-jds-text': {
          'font-family': '{text_137}',
          'font-size': '{text_136}',
          'line-height': '{text_138}',
          'letter-spacing': '{text_139}',
          'font-weight': '{text_140}'
        }
      },
      'xtra-xtra-xtra-xtra-large': {
        'inner-container': {
          width: '{b_27}',
          height: '{b_28}'
        },
        'label-jds-text': {
          'font-family': '{text_122}',
          'font-size': '{text_121}',
          'line-height': '{text_123}',
          'letter-spacing': '{text_124}',
          'font-weight': '{text_125}'
        },
        'symbol-jds-text': {
          'font-family': '{text_122}',
          'font-size': '{text_121}',
          'line-height': '{text_123}',
          'letter-spacing': '{text_124}',
          'font-weight': '{text_125}'
        }
      }
    },
    border: {
      true: {
        container: {
          'padding-left': '{b_30}',
          'padding-right': '{b_30}',
          'padding-top': '{b_30}',
          'padding-bottom': '{b_30}'
        }
      }
    }
  },
  combination: [
    {
      number: {
        'xtra-small': {
          'inner-container': {
            width: '{b_31}',
            height: '{b_32}'
          }
        },
        small: {
          'inner-container': {
            width: '{b_33}',
            height: '{b_34}'
          }
        },
        medium: {
          'inner-container': {
            width: '{b_35}',
            height: '{b_36}'
          }
        },
        large: {
          'inner-container': {
            width: '{b_37}',
            height: '{b_38}'
          }
        },
        'xtra-large': {
          'inner-container': {
            width: '{b_39}',
            height: '{b_40}'
          }
        },
        'xtra-xtra-large': {
          'inner-container': {
            width: '{b_41}',
            height: '{b_42}'
          }
        },
        'xtra-xtra-xtra-large': {
          'inner-container': {
            width: '{b_43}',
            height: '{b_44}'
          }
        },
        'xtra-xtra-xtra-xtra-large': {
          'inner-container': {
            width: '{b_45}',
            height: '{b_46}'
          }
        }
      },
      'number-symbol': {
        'xtra-small': {
          container: {
            'border-radius': '{b_48}'
          },
          'inner-container': {
            width: '',
            height: '{b_47}',
            'border-radius': '{b_48}',
            'padding-left': '{b_49}',
            'padding-right': '{b_50}'
          }
        },
        small: {
          container: {
            'border-radius': '{b_52}'
          },
          'inner-container': {
            width: '',
            height: '{b_51}',
            'border-radius': '{b_52}',
            'padding-left': '{b_53}',
            'padding-right': '{b_54}'
          }
        },
        medium: {
          container: {
            'border-radius': '{b_56}'
          },
          'inner-container': {
            width: '',
            height: '{b_55}',
            'border-radius': '{b_56}',
            'padding-left': '{b_57}',
            'padding-right': '{b_58}'
          }
        },
        large: {
          container: {
            'border-radius': '{b_60}'
          },
          'inner-container': {
            width: '',
            height: '{b_59}',
            'border-radius': '{b_60}',
            'padding-left': '{b_61}',
            'padding-right': '{b_62}'
          }
        },
        'xtra-large': {
          container: {
            'border-radius': '{b_64}'
          },
          'inner-container': {
            width: '',
            height: '{b_63}',
            'border-radius': '{b_64}',
            'padding-left': '{b_65}',
            'padding-right': '{b_66}'
          }
        },
        'xtra-xtra-large': {
          container: {
            'border-radius': '{b_68}'
          },
          'inner-container': {
            width: '',
            height: '{b_67}',
            'border-radius': '{b_68}',
            'padding-left': '{b_69}',
            'padding-right': '{b_70}'
          }
        },
        'xtra-xtra-xtra-large': {
          container: {
            'border-radius': '{b_72}'
          },
          'inner-container': {
            width: '',
            height: '{b_71}',
            'border-radius': '{b_72}',
            'padding-left': '{b_73}',
            'padding-right': '{b_74}'
          }
        },
        'xtra-xtra-xtra-xtra-large': {
          container: {
            'border-radius': '{b_76}'
          },
          'inner-container': {
            width: '',
            height: '{b_75}',
            'border-radius': '{b_76}',
            'padding-left': '{b_77}',
            'padding-right': '{b_78}'
          }
        }
      }
    },
    {
      true: {
        small: {
          container: {
            'padding-left': '{b_9}',
            'padding-right': '{b_9}',
            'padding-top': '{b_9}',
            'padding-bottom': '{b_9}'
          }
        },
        medium: {
          container: {
            'padding-left': '{b_14}',
            'padding-right': '{b_14}',
            'padding-top': '{b_14}',
            'padding-bottom': '{b_14}'
          }
        },
        large: {
          container: {
            'padding-left': '{b_17}',
            'padding-right': '{b_17}',
            'padding-top': '{b_17}',
            'padding-bottom': '{b_17}'
          }
        },
        'xtra-large': {
          container: {
            'padding-left': '{b_20}',
            'padding-right': '{b_20}',
            'padding-top': '{b_20}',
            'padding-bottom': '{b_20}'
          }
        },
        'xtra-xtra-large': {
          container: {
            'padding-left': '{b_23}',
            'padding-right': '{b_23}',
            'padding-top': '{b_23}',
            'padding-bottom': '{b_23}'
          }
        },
        'xtra-xtra-xtra-large': {
          container: {
            'padding-left': '{b_26}',
            'padding-right': '{b_26}',
            'padding-top': '{b_26}',
            'padding-bottom': '{b_26}'
          }
        },
        'xtra-xtra-xtra-xtra-large': {
          container: {
            'padding-left': '{b_29}',
            'padding-right': '{b_29}',
            'padding-top': '{b_29}',
            'padding-bottom': '{b_29}'
          }
        }
      }
    },
    {
      true: {
        number: {
          'xtra-small': {
            container: {
              'padding-left': '{b_79}',
              'padding-right': '{b_79}',
              'padding-top': '{b_79}',
              'padding-bottom': '{b_79}'
            }
          }
        },
        'number-symbol': {
          'xtra-small': {
            container: {
              'padding-left': '{b_79}',
              'padding-right': '{b_79}',
              'padding-top': '{b_79}',
              'padding-bottom': '{b_79}'
            }
          }
        }
      }
    }
  ],
  combination_config: [
    ['kind', 'size'],
    ['border', 'size'],
    ['border', 'kind', 'size']
  ],
  api: {
    config: {
      kind: {
        values: ['dot', 'number', 'number-symbol']
      },
      size: {
        values: [
          'xtra-small',
          'small',
          'medium',
          'large',
          'xtra-large',
          'xtra-xtra-large',
          'xtra-xtra-xtra-large',
          'xtra-xtra-xtra-xtra-large'
        ]
      },
      border: {
        values: [false, true]
      }
    },
    data: {
      'label-jds-text': {
        value: {
          type: 'string',
          name: 'label'
        }
      }
    },
    a11y: {
      container: {
        properties: {
          'aria-label': {
            name: 'ariaLabel',
            value: 'Active Notification'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
